import { render, staticRenderFns } from "./PrivacyPolicyEn.vue?vue&type=template&id=0a9b59c6&scoped=true&"
import script from "./PrivacyPolicyEn.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyEn.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyEn.vue?vue&type=style&index=0&id=0a9b59c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b59c6",
  null
  
)

export default component.exports